import React, {useEffect, useState} from 'react';
import ReactMarkdown from 'react-markdown';
import Footer from '../../core/layout/footer/footer';
import './TermsOfService.css';

function TermsOfService() {
    const [content, setContent] = useState('');

    // terms-of-service.md this file is present in public/ folder
    useEffect(() => {
        window.scrollTo(0, 0);
        fetch('/terms-of-service.md')
            .then(res => res.text())
            .then(setContent)
            .catch(() => setContent('# Terms of Service\n\nContent could not be loaded.'));
    }, []);

    return (
        <div className="w-100">
            <div className="pp-page">
                <div className="pp-wrap">
                    <div className="pp-content">
                        <ReactMarkdown>{content}</ReactMarkdown>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default TermsOfService;
